<upp-kb-language-input #input
    [ngClass]="{ 'title': (value !== null) }"
    [ngStyle]="{ 'margin-bottom': formControl?.errors ? '15px' : '0px' }"
    [kiosk]="kiosk"
    [lang]="lang"
    [name]="formControlName"
    [placeholder]="placeholder"
    [value]="value"
    [readonly]="readonly"
    [disabled]="_disabled"
    (Changed)="value = $event"
></upp-kb-language-input>
<ion-label class="input-title" [ngClass]="{ 'hide': !showTitle }">{{viewTitle}}</ion-label>
<upp-er-input *ngIf="formGroup"
    [form]="formGroup"
    [name]="formControlName"
    [value]="activeText"
    [errornfo]="errornfo"
></upp-er-input>
